<template>

    <div class="result-index">
		<div class="page-title">
			<h1>診断結果</h1>
			<div class="semi">Your Introvert Result</div>
		</div><!-- end .page-title -->
		<div class="wrapper">
			<div class="summary">
				<div class="box-wrapper">
					<ResultIndexLevelChart></ResultIndexLevelChart>
					<div class="box-chart">
						<LevelDoughnut v-bind:levelScorePercentageArray="levelScorePercentageArray" v-bind:levelColor="levelColor"></LevelDoughnut>
					</div><!-- end .box-chart -->
				</div><!-- end .box-wrapper -->
			</div><!-- end .summary -->
			<ResultIndexProgress></ResultIndexProgress>		
		</div><!-- end .wrapper -->
		<div class="guidance" v-if="levelResult.percentage >= 50">
			<ResultIndexLevelIntrovert></ResultIndexLevelintrovert>
		</div><!-- end .guidance -->
		<div class="guidance" v-if="levelResult.percentage < 50">
			<ResultIndexLevelOutrovert></ResultIndexLevelOutrovert>
		</div><!-- end .guidance -->
    </div><!-- end .result-index -->
</template>

<script>
import LevelDoughnut from '../components/LevelDoughnut.vue'
import ResultIndexLevelChart from '../components/ResultIndexLevelChart.vue'
import ResultIndexProgress from '../components/ResultIndexProgress.vue'
import ResultIndexLevelIntrovert from '../components/ResultIndexLevelIntrovert.vue'
import ResultIndexLevelOutrovert from '../components/ResultIndexLevelOutrovert.vue'

export default {
	name: 'ResultIndexTest',
	components: {
		LevelDoughnut,
		ResultIndexLevelChart,
		ResultIndexProgress,
		ResultIndexLevelIntrovert,
		ResultIndexLevelOutrovert
	},
	
	data: function () {
		return {
			bgWidth:100,
			levelTitle:'内向度',
			levelColor:['#359799','#a6b9b9'],
		}
	},
	head: {
		title: {inner:'診断結果｜超詳細】内向型診断テスト「イントロバーツ」'},
		meta: [
			{ name: 'description', content: '断結果は5000字以上！今のあなたの内向度と、あなたの行動やマインドを総合的に分析し、あなたの内向性をビジネスやプライベートで生かすためのノウハウを丁寧にアドバイス！' },
			{ property: 'og:title', content: '診断結果｜【超詳細】内向型診断テスト「イントロバーツ」' },
			{ property: 'og:description', content: '断結果は5000字以上！今のあなたの内向度と、あなたの行動やマインドを総合的に分析し、あなたの内向性をビジネスやプライベートで生かすためのノウハウを丁寧にアドバイス！' },
			{ property: 'og:type', content: 'article' },
			{ property: 'og:url', content: 'https://introverts.jp/#/result-index' },
			// { property: 'og:image', content: 'https://example.com/img/og.png' },
			// { name: 'twitter:card', content: 'summary' }
		]
	},
	props:[
		
	],
	methods:{

	},
	computed: {
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		levelScorePercentageArray:function(){
			let levelScorePercentageArray =[Number(this.levelResult.percentage) ,Number(100-this.levelResult.percentage)];
			return levelScorePercentageArray;
		},
	},
	created() {
		//alert('hoge is: ' + this.hoge);
		window.scrollBy({
			top: -document.body.clientHeight,
			behavior: 'smooth'
		});		
	},	
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
/*===================================================================
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □

〇 .result-index pc 〇

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □      
====================================================================*/
.result-index .page-title{
	background:#359799;
	text-align: center;
	width:100%;
	padding:60px 0 60px 0;

	h1{
		font-size:42px;
		color:#fff;
		letter-spacing: 2px;
		padding:0 0 7px 0;
	}
	.semi{
		font-size:17px;
		color:#fff;
		letter-spacing: 1px;
		font-weight: bold;
	}
}
.result-index .wrapper{
	max-width:1280px;
	margin:50px auto 20px;
	display: flex;
	justify-content: space-between;
}
/*==============================================
.summary
===============================================*/
.result-index .wrapper .summary{
	width:47.5%;
	display: flex;
	justify-content: center;
	align-items: center;
	.level-title{
		display: flex;
		justify-content: center;
		line-height: 1.25;
		padding:20px 0 0 0;

		img{
			width:80px;
			height: 80px;
			position: relative;
			top:0px;
		}

		.text{
			padding:0 0 0 15px;
		}
	}

	h2{
		font-size:25px;
		letter-spacing: 1px;
		margin:0;
		padding: 0;
	}

	h3{
		font-size:15px;
		letter-spacing: 1px;
		color:#359799;
		margin:10px 0 10px 0;
		padding: 0;
	}

	.percentage{
		font-size:140px;
		font-weight: bold;
		line-height: 1.0;
		padding:0px 0 0px 0;
		color:#359799;

		

		span{
			font-size:20px;
		}
	}

	.sentence{
		width:50%;
		font-weight: bold;
		margin:0 auto 0;
		font-size:15px;
		letter-spacing: 1px;
		
	}
}



/*==============================================
.result-index .wrapper .box-wrapper
===============================================*/
.result-index .wrapper .box-wrapper{
	position: relative;
	width: 100%;
	padding:0px 0 0 0;
	margin:0 auto 20px;

	.box-title{
	position: absolute;
	z-index: 1;
	top:50%;
	left: 50%;
	transform: translate(-50%,-50%);
	width: 92%;
	margin:0 auto 0;	
	}
	.box-chart{
	width: 100%;
	height: 100%;


	}
}

/*==============================================
.guidance 
===============================================*/
.result-index .guidance{
	margin:70px 0 50px 0;
}

.result-index .guidance .title{
	padding:0px 0 0px 0;
	background:#359799;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	flex-direction: row-reverse;
	font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
	line-height: 0;

	.text{
		margin:0 0 0 40px;
		color:#fff;
		padding:50px 0 50px 0;
		line-height: 1.75;
		h2{
			font-size:42px;
			
		}
		h3{
			font-size:20px;
		}
		.en{
			font-size:16px;
		}
	}

	img{
		width:480px;
		height: auto;
		position: relative;
		top:1px;
	}

}

.result-index .guidance .sentence{
	text-align: left;
	max-width: 1000px;
	margin:40px auto 0;
	.type{
		font-size:20px;
		color:#359799;
		font-weight: bold;
		span{
			background:#359799;
			color:#fff;
			margin:0 10px 0 0;
			border-radius: 30px;
			padding:3px 15px 3px 15px;
			font-size:18px;
		}
	}
	h2{
		color:#359799;
		font-size:38px;
		font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
		margin:0 0 15px 0;
	}
	h3{
		color:#359799;
		font-size:35px;
		font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
		margin:55px 0 20px 0;	
	}

	h4{
		color:#359799;
		font-size:35px;
		padding:10px 0 0px 0;
		text-align: center;
		font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
		margin:55px 0 25px 0;
		font-weight: normal;	
	}

	h5{
		color:#359799;
		font-size:22px;
		text-align: center;
		font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
		margin:0px 0 20px 0;
		font-weight: normal;
	}

	p{
		font-size:20px;
		padding:15px 0 15px 0;
		letter-spacing: 1px;
		line-height: 2.0;
		color:#3f3f3f;
		font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
	}
	img{
		width:600px;
		height: auto;
		display: block;
		margin:60px auto 0;
	}
	.caption{
		width:600px;
		margin:0 auto;
		text-align: left;
		font-family:"Meiryo UI" , "メイリオ" , Meiryo, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", Arial,sans-serif;
		color:#707070;
		text-align: center;
		padding:10px 0 40px 0;
		font-size:16px;
	}

	.next{
		width:410px;
		margin:20px auto 45px;
		display: block;
		background:#269c9f;
		color:#fff;
		font-size:25px;
		text-align: center;
		border-radius:30px;
		padding:14px 20px 14px 5px;
		box-shadow: 0 2px 25px rgba(204, 204, 204, 0.5);
		position: relative;
		z-index: 1;
		text-decoration: none;

		&::before{
			content:"";
			display: inline-block;
			position:absolute;
			top:50%;
			transform: translateY(-50%);
			right:20px;
			width: 22px;
			height: 22px;
			z-index: 2;
			background-image:url(../assets/next.svg);
			background-repeat:no-repeat;
			background-position: right center;
			background-size:auto 22px;
		}
	}
}

/**********************************************************************************
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □  

◆	Stylesheet: 768px～1023px(iPad縦からiPad横)までのモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/

@media screen and (min-width: 768px) and (max-width: 1023px) {
	.result-index .wrapper{
		margin:20px auto 20px;
		justify-content: space-around;
	}
	/*==============================================
	.summary
	===============================================*/
	.result-index .wrapper .summary{
		width:49.5%;
		.level-title{
			padding:20px 0 0 0;

			img{
				width:10vw;
				height: auto;
			}

			.text{
				padding:0 0 0 10px;
			}
		}

		h2{
			font-size:3vw;
			letter-spacing: 1px;
		}

		h3{
			font-size:1.76vw;
			letter-spacing: 1px;
			margin:10px 0 5px 0;

		}

		.percentage{
			font-size:13vw;
			font-weight: bold;
			line-height: 0.8;
			padding:0px 0 12px 0;


			span{
				font-size:5vw;
			}
		}

		.sentence{
			width:50%;
			font-weight: bold;
			margin:0 auto 0;
			font-size:1.8vw;
			letter-spacing: 1px;
			
		}
	}


	/*==============================================
	.guidance 
	===============================================*/
	.result-index .guidance{
		margin:45px 0 50px 0;
	}
	.result-index .guidance .title{
		display: block;
		.text{
			margin:0 0 0 40px;
			padding:50px 0 50px 0;
			line-height: 1.75;
			h2{
				font-size:42px;
			}
			h3{
				font-size:20px;
			}
			.en{
				font-size:16px;
			}
		}

		img{
			width:480px;
			height: auto;
		}

	}


	.result-index .guidance .sentence{
		padding:0 5% 0 5%;
		margin:40px auto 0;
		.type{
			font-size:2.25vw;
			span{
				padding:3px 15px 3px 15px;
				font-size:2.0vw;
			}
		}
		h2{

			font-size:4.25vw;

			margin:0 0 15px 0;
		}
		h3{
			font-size:4.25vw;
			margin:55px 0 20px 0;	
		}

		h4{

			font-size:4vw;
			padding:10px 0 0px 0;
			margin:55px 0 25px 0;
		}

		h5{
			
			font-size:3vw;
			margin:0px 0 20px 0;
		}

		p{
			font-size:2.25vw;
			padding:15px 0 15px 0;
			letter-spacing: 1px;
			line-height: 2.0;

		}
		img{
			width:600px;
			height: auto;
			display: block;
			margin:60px auto 0;
		}
		.caption{
			width:450px;
			padding:10px 0 40px 0;
			font-size:1.8vw;
		}

		.next{
			width:410px;
			margin:20px auto 45px;
			display: block;
			background:#269c9f;
			color:#fff;
			font-size:25px;
			text-align: center;
			border-radius:60px;
			padding:14px 20px 14px 5px;
			box-shadow: 0 2px 25px rgba(204, 204, 204, 0.5);
			position: relative;
			z-index: 1;
			text-decoration: none;

			&::before{
				content:"";
				display: inline-block;
				position:absolute;
				top:50%;
				transform: translateY(-50%);
				right:20px;
				width: 22px;
				height: 22px;
				z-index: 2;
				background-image:url(../assets/next.svg);
				background-repeat:no-repeat;
				background-position: right center;
				background-size:auto 22px;
			}
		}
	}
} /* 768px～1023px responsive-closed */

/**********************************************************************************
 □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 

◆	Stylesheet: 767pxまで(スマホ)のモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/
@media screen and (max-width: 767px) {
	.result-index .wrapper{
		margin:30px auto 0px;
		display: block;
	}

	/*==============================================
	.summary
	===============================================*/
	.result-index .wrapper .summary{
		width:100%;
		margin:0 0 15px 0;
		.level-title{
			display: flex;
			justify-content: center;
			line-height: 1.25;
			img{
				width:30px;
				height: 30px;
			}
			.text{
				padding:0 0 0 0px;
			}
		}
		h2{
			font-size:20px;
			letter-spacing: 1px;
			margin:0;
		}
		h3{
			font-size:12px;
			letter-spacing: 1px;
			color:#359799;
			margin:0;
		}
		.percentage{
			font-size:100px;
			line-height: 1.0;
			padding:10px 0 0 0;
			span{
				font-size:17px;
			}
		}
		.sentence{
			width:50%;
			font-size:13px;
			letter-spacing: 1px;
		}
	}


	/*==============================================
	.summary .box-wrapper
	===============================================*/
	.result-index .wrapper .box-wrapper{
		width: 94%;
		padding:0px 0 0 0;
		margin:0 auto 10px;
	}


	/*==============================================
	.guidance 
	===============================================*/
	.result-index .guidance{
		margin:40px 0 40px 0;
	}

	.result-index .guidance .title{
		display: block;
		.text{
			margin:0 auto 0;
			padding:50px 3% 30px 3%;
			h2{
				font-size:9vw;
				
			}
			h3{
				font-size:4.5vw;
			}
			.en{
				font-size:15px;
			}
		}

		img{
			width:90%;
			height: auto;
		}
	}

	.result-index .guidance .sentence{
		text-align: left;
		margin:40px auto 0;
		.type{
			font-size:4vw;
			padding:0 5% 5px 5%;

			span{
				background:#359799;
				font-size:3.7vw;
				color:#fff;
				margin:0 1.35vw 0 0;
				border-radius: 30px;
				padding:3px 15px 3px 15px;
				
			}
		}
		h2{
			font-size:6.5vw;
			margin:0 0 15px 0;
			padding:0 5% 0 5%;
		}
		h3{
			font-size:6.5vw;
			padding:0 5% 0 5%;
			margin:35px 0 15px 0;	
		}

		h4{
			font-size:6.0vw;
			padding:10px 5% 0px 5%;
			margin:5px 0 25px 0;
		}

		h5{	
			font-size:16px;
			margin:0px 5% 20px 5%;
		}

		p{
			font-size:4.0vw;
			padding:15px 5% 15px 5%;
			letter-spacing: 0.25px;
			line-height: 2.0;
		}
		img{
			width:92%;
			margin:35px auto 0;
		}
		.caption{
			width:92%;
			margin:0 auto;
			text-align: center;
			padding:10px 0 25px 0;
			font-size: 3.25vw;
		}

		.next{
			width:90%;
			margin:20px auto 25px;
			display: block;
			font-size:22px;
			border-radius:30px;
			padding:14px 20px 14px 5px;

			&::before{
				content:"";
				right:20px;
				width: 20px;
				height: 20px;
				background-size:auto 20px;
			}
		}
	}
} /* 767px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/


/**********************************************************************************
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □   

◆	Stylesheet: さらに刻んで320pxまでのモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/

@media screen and (max-width: 320px) {
	/*==============================================
	.summary
	===============================================*/
	.result-index .wrapper .summary{		
		.level-title{
			img{
				width:28px;
				height: 28px;
			}

			.text{
				padding:0 0 0 5px;
			}
		}

		h2{
			font-size:17px;
			
		}

		h3{
			font-size:11px;
			letter-spacing: 0.5px;
		}

		.percentage{
			font-size:90px;
			line-height: 1.0;
			padding:0px 0 0 0;
			span{
				font-size:17px;
			}
		}

		.sentence{
			width: 60%;
			font-size:11px;
			letter-spacing: 1px;
		}
	}


	/*==============================================
	.summary .box-wrapper
	===============================================*/
	.result-index .wrapper .box-wrapper{
		width: 96%;
		padding:0px 0 0 0;
	}



	/*==============================================
	.guidance
	===============================================*/
	.result-index .guidance .sentence{

		h2{

			margin:0 0 15px 0;
			padding:0 5% 0 5%;
		}
		h3{

			padding:0 5% 0 5%;
			margin:35px 0 15px 0;	
		}

		h4{

			padding:10px 3.5% 0px 3.5%;
		}

		h5{	
			font-size:16px;
			margin:0px 5% 20px 5%;
		}




	}
} /* 320px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/
</style>
